import React from 'react';
import { Stack, Typography } from '@mui/material';
import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';

interface ApproverInfoProps {
  requiredApprover?: string | null;
  backupApprover?: string | null;
}

/**
 * Displays approver name with optional backup approver.
 */
export const ApproverInfo: React.FC<ApproverInfoProps> = ({ requiredApprover, backupApprover }) => (
  <Stack direction="column" spacing={0.25}>
    <Typography
      variant="body2"
      sx={{
        fontWeight: 500,
        fontSize: '0.75rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '160px'
      }}
      title={requiredApprover || 'Not assigned'}
    >
      {requiredApprover || 'Not assigned'}
    </Typography>
    {backupApprover && (
      <Typography
        variant="caption"
        sx={{
          color: '#64748b',
          fontSize: '0.7rem',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '160px'
        }}
        title={`Backup: ${backupApprover}`}
      >
        Backup: {backupApprover}
      </Typography>
    )}
  </Stack>
);

/** Syncfusion grid template wrapper */
export const approverTemplate = (props: WriteoffApprovalView) => (
  <ApproverInfo 
    requiredApprover={props.requiredApprover} 
    backupApprover={props.backupApprover} 
  />
);

export default ApproverInfo;
